import { Link } from 'react-router-dom'
import { DeployCommit } from '../DeployCommit'
import { landingLinkClass } from './landingLinkStyles'

export function LandingNav() {
  return (
    <header className="relative z-10 flex items-center justify-between px-4 py-5 sm:px-8">
      <Link
        to="/"
        className="text-lg font-semibold tracking-tight text-text-primary hover:text-accent"
      >
        Pingscalate
      </Link>
      <nav className="flex items-center gap-2 sm:gap-3">
        <Link to="/uptime-monitoring" className={landingLinkClass('ghost', 'sm')}>
          Learn
        </Link>
        <Link to="/pricing" className={landingLinkClass('ghost', 'sm')}>
          Pricing
        </Link>
        <Link
          to="/login"
          state={{ from: '/status' }}
          className={landingLinkClass('ghost', 'sm')}
        >
          Sign In
        </Link>
        <Link to="/signup" className={landingLinkClass('primary', 'sm')}>
          Start Free
        </Link>
        <DeployCommit />
      </nav>
    </header>
  )
}
